import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";
import SiteFooter from "@/components/SiteFooter";

const LOGO_URL = "/logo-gabriele-sauer.png";

const HomePage = () => {
  return (
    <div className="page-shell" data-testid="home-page">
      <main className="page-main" data-testid="home-main-content">
        <header className="brand-header" data-testid="brand-header">
          <img className="brand-logo" src={LOGO_URL} alt="Art of Life Logo" data-testid="brand-logo" />
        </header>

        <section className="hero-grid" data-testid="hero-grid">
          <motion.div
            className="hero-content"
            data-testid="hero-content"
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <p className="hero-kicker" data-testid="hero-kicker">
              Art of Life · Gabriele Sauer
            </p>
            <h1 className="hero-title" data-testid="hero-title">
              Die neue Seite befindet sich aktuell im Aufbau.
            </h1>
            <p className="hero-subtitle" data-testid="hero-subtitle">
              Vielen Dank für Ihre Geduld. Für Termin- oder Kontaktanfragen sind wir gerne
              telefonisch für Sie erreichbar.
            </p>

            <div className="contact-card" data-testid="contact-card">
              <p className="contact-title" data-testid="contact-title">
                Telefonischer Kontakt
              </p>
              <div className="phone-list" data-testid="phone-list">
                <a
                  className="phone-link"
                  href="tel:+4917620197960"
                  data-testid="phone-link-mobile"
                  aria-label="Mobilnummer anrufen"
                >
                  <Phone size={20} className="icon-red" aria-hidden="true" />
                  <span className="phone-label">Mobil:</span> 0176 20 19 79 60
                </a>

                <a
                  className="phone-link"
                  href="tel:+4997113191388"
                  data-testid="phone-link-landline"
                  aria-label="Festnetznummer anrufen"
                >
                  <Phone size={20} className="icon-red" aria-hidden="true" />
                  <span className="phone-label">Festnetz:</span> 0971 13 19 13 88
                </a>

                <a
                  className="phone-link email-link"
                  href="mailto:info@gabriele-sauer-reiki.de"
                  data-testid="email-link-main"
                  aria-label="E-Mail schreiben"
                >
                  <Mail size={20} className="icon-red" aria-hidden="true" />
                  <span className="phone-label">E-Mail:</span> info@gabriele-sauer-reiki.de
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="hero-visual"
            data-testid="hero-visual"
            initial={{ opacity: 0, y: 26 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
          >
            <div className="visual-card" data-testid="hero-visual-card">
              <div className="visual-gradient" data-testid="hero-visual-gradient" />
              <div className="visual-overlay" data-testid="hero-visual-overlay" />
            </div>
          </motion.div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
};

export default HomePage;